const SeverityValues = [
  { value: "Mild", name: "Mild" },
  { value: "Moderate", name: "Moderate" },
  { value: "Severe", name: "Severe" },
];

export default SeverityValues;
